import React from 'react';

// components
import FormattedMessageV2, { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';
import Header from '@/views/components/layout/Header';

// Types
import Nullable from '@/types/nullable';

export type PageLayoutProps = {
  children?: React.ReactNode;
  layoutClassName?: string;
  mainClassName?: string;
  pageActionsElement?: Nullable<JSX.Element>;
  pageTitle?: string;
  pillsFilterElement?: Nullable<JSX.Element>;
  searchInputElement?: Nullable<JSX.Element>;
  showHeader?: boolean;
  showPage?: boolean;
};

const PageLayout = ({
  pageActionsElement,
  children,
  layoutClassName = '',
  mainClassName = '',
  pageTitle,
  pillsFilterElement,
  searchInputElement,
  showHeader = true,
  showPage = true,
}: PageLayoutProps) => (
  <>
    {showPage && (
      <>
        {showHeader && <Header />}
        <div className={`page-layout ${layoutClassName}`}>
          <main id="content" className={`page-layout-container ${mainClassName}`}>
            <div className="page-body">
              <div
                className={[
                  'page-header',
                  (pillsFilterElement || searchInputElement || pageActionsElement) && 'has-header-content',
                  (searchInputElement || pageActionsElement) && 'has-cta',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                <div className="page-header-title-container">
                  {pageTitle && <FormattedMessageV2 className="page-title" tagName={ALLOWED_HTML_TAGS.H1} toLocalize={pageTitle} />}
                  {pillsFilterElement && <div className="page-pills">{pillsFilterElement}</div>}
                </div>

                {(searchInputElement || pageActionsElement) && (
                  <div className="page-search-cta-container">
                    {searchInputElement && <div className="page-search">{searchInputElement}</div>}
                    {pageActionsElement && <div className="page-actions-section">{pageActionsElement}</div>}
                  </div>
                )}
              </div>
              <div className="page-content">{children}</div>
            </div>
          </main>
        </div>
      </>
    )}
  </>
);

export default PageLayout;
